module.exports = __webpack_public_path__ + "static/img/YP.acb0bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/YP.png
// module id = Xkst
// module chunks = 0